<div class="modal-header">
	<h4 class="modal-title">
		Muokkaa tageja
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="close()"
	></button>
</div>

<div class="modal-body">
	<div
		*ngIf="sourceMaterialService.Tags.length === 0"
		class="text-center text-muted py-5"
	>
		<i class="bi bi-tags display-4 text-muted"></i>
		<p class="mt-3 mb-0">Ei tageja. Lisää ensimmäinen tagi alapuolelta.</p>
	</div>

	<div *ngIf="sourceMaterialService.Tags.length > 0" class="table-responsive">
		<table class="table table-hover mb-0">
			<thead>
				<tr>
					<th
						scope="col"
						class="sortable-header"
						(click)="sortTags('name')"
					>
						Tagi
						<i class="ms-1" [ngClass]="getSortIcon('name')"></i>
					</th>
					<th
						scope="col"
						class="sortable-header"
						(click)="sortTags('description')"
					>
						Kuvaus
						<i
							class="ms-1"
							[ngClass]="getSortIcon('description')"
						></i>
					</th>
					<th
						scope="col"
						class="text-center sortable-header"
						style="width: 100px"
						(click)="sortTags('usage')"
					>
						Tiedostot
						<i class="ms-1" [ngClass]="getSortIcon('usage')"></i>
					</th>
					<th scope="col" class="text-end" style="width: 120px"></th>
				</tr>
			</thead>
			<tbody>
				@for (tag of sortedTags; track $index) {
					<tr class="align-middle" (click)="startEditTag(tag)">
						<!-- Normal view -->
						<ng-container *ngIf="editingTag?.id !== tag.id">
							<td>
								<span style="color: #909090">#</span>
								<strong>{{ tag.name }}</strong>
							</td>
							<td>
								<span class="text-muted">{{
									tag.description || ""
								}}</span>
							</td>
							<td class="text-center text-muted">
								<span *ngIf="getTagUsageCount(tag.id) > 0">
									{{ getTagUsageCount(tag.id) }}
								</span>
							</td>
							<td class="text-end">
								<div class="tag-actions">
									<button
										type="button"
										class="btn btn-sm btn-outline-secondary border-0 fs-5"
										(click)="
											$event.stopPropagation();
											startEditTag(tag)
										"
										title="Muokkaa tagiä"
									>
										<i class="bi bi-pencil"></i>
									</button>
									<button
										type="button"
										class="btn btn-sm btn-outline-danger border-0 fs-5"
										(click)="
											$event.stopPropagation();
											deleteTag(tag)
										"
										title="Poista tagi"
									>
										<i class="bi bi-trash"></i>
									</button>
								</div>
							</td>
						</ng-container>

						<!-- Edit form -->
						<ng-container *ngIf="editingTag?.id === tag.id">
							<td colspan="4" class="p-3">
								<div class="row g-3">
									<div class="col-12">
										<strong>Muokkaa tagia</strong>
									</div>
									<div class="col-md-5">
										<label class="form-label small"
											>Tagi</label
										>
										<div class="input-group input-group-sm">
											<span class="input-group-text"
												>#</span
											>
											<input
												type="text"
												class="form-control"
												[(ngModel)]="editTagForm.Name"
												(keyup.enter)="saveEditTag()"
												[disabled]="isEditingTag"
											/>
										</div>
									</div>
									<div class="col-md-5">
										<label class="form-label small"
											>Kuvaus</label
										>
										<input
											type="text"
											class="form-control form-control-sm"
											[(ngModel)]="
												editTagForm.Description
											"
											(keyup.enter)="saveEditTag()"
											[disabled]="isEditingTag"
										/>
									</div>
									<div
										class="col-md-2 d-flex align-items-end"
									>
										<button
											type="button"
											class="btn btn-primary btn-sm me-2"
											(click)="
												$event.stopPropagation();
												saveEditTag()
											"
											[disabled]="
												!editTagForm.Name.trim() ||
												isEditingTag
											"
										>
											<span
												*ngIf="isEditingTag"
												class="spinner-border spinner-border-sm me-1"
												role="status"
												aria-hidden="true"
											></span>
											<i
												*ngIf="!isEditingTag"
												class="bi bi-check"
											></i>
										</button>
										<button
											type="button"
											class="btn btn-outline-secondary btn-sm"
											(click)="
												$event.stopPropagation();
												cancelEdit()
											"
											[disabled]="isEditingTag"
										>
											<i class="bi bi-x"></i>
										</button>
									</div>
								</div>
							</td>
						</ng-container>
					</tr>
				}
			</tbody>
		</table>
	</div>

	<div class="text-center pt-3 pb-2">
		<button
			type="button"
			class="btn btn-primary"
			(click)="openAddTagModal()"
			title="Lisää uusi tagi"
		>
			<i class="bi bi-plus"></i> Lisää tagi
		</button>
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="close()">
		Sulje
	</button>
</div>
